import type {
  DelegatedResult,
  DelegationRepository,
} from 'uniswap/src/features/smartWallet/delegation/delegationRepository'
import type { Logger } from 'utilities/src/logger/logger'

export type { DelegatedResult } from 'uniswap/src/features/smartWallet/delegation/delegationRepository'

export function createDelegationService(ctx: {
  logger?: Logger
  delegationRepository: DelegationRepository
  onDelegationDetected?: (input: { address: Address; chainId: number }) => void
}): DelegationService {
  return {
    getIsAddressDelegated: async (input: { address: Address; chainId: number }): Promise<DelegatedResult> => {
      const result = await ctx.delegationRepository.getWalletDelegations({
        address: input.address,
        chainIds: [input.chainId],
      })
      const delegationDetails = result[String(input.chainId)]
      const delegatedAddress = delegationDetails?.currentDelegationAddress

      if (delegatedAddress) {
        ctx.onDelegationDetected?.({ address: delegatedAddress, chainId: input.chainId })
        ctx.logger?.info(
          'delegation.ts',
          'getIsAddressDelegated',
          `Address ${input.address} is delegated on chain ${input.chainId} to ${delegatedAddress}`,
        )
        return {
          isDelegated: true,
          delegatedAddress,
        }
      }

      return {
        isDelegated: false,
        delegatedAddress: null,
      }
    },
  }
}

export interface DelegationService {
  getIsAddressDelegated: (input: { address: Address; chainId: number }) => Promise<DelegatedResult>
}
